"use strict";
/**
 * Формы объектов, которые API отдаёт наружу.
 *
 * DTO никогда не содержат password hash, session token, reset token, серверный
 * путь хранения файла и прочие внутренние данные (документ «Технический план», §7).
 * Даты передаются строками ISO 8601 в UTC; часовой пояс применяет интерфейс.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPORT_MODE_LABELS_RU = exports.IMPORT_MODES = void 0;
// --- Импорт --------------------------------------------------------------
/**
 * Как файл ложится на существующие данные.
 *
 * Три режима отвечают на три разных вопроса, и путать их нельзя: «сделай
 * копию», «подтяни изменения» и «добавь недостающее» — это три разных
 * намерения, а не настройки одного.
 *
 *   CREATE_NEW      — новый проект. Существующие не затрагиваются.
 *   UPDATE_EXISTING — обновляет проект: что новее в файле, то и берётся.
 *   MERGE           — дополняет проект, ничего не переписывая.
 *
 * Ни один режим ничего не удаляет. Того, что есть в проекте и чего нет в
 * файле, импорт не трогает: файл — это чей-то снимок, а не приговор тому,
 * что произошло здесь после снимка.
 */
exports.IMPORT_MODES = ['CREATE_NEW', 'UPDATE_EXISTING', 'MERGE'];
/** Названия режимов для интерфейса. */
exports.IMPORT_MODE_LABELS_RU = {
    CREATE_NEW: 'Новый проект',
    UPDATE_EXISTING: 'Обновить существующий',
    MERGE: 'Дополнить существующий',
};
//# sourceMappingURL=dto.js.map